import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { EnumLogLevel, HATSWebH3 } from '@bytni/hatswebh3';
import { getServiceHost } from 'by-route-finder';
import { isProd, isProdOrTestnet, isTestnet, isTest } from 'by-env';

// SDK文档：https://c1ey4wdv9g.larksuite.com/wiki/wikuszRoUSDDa6AwBLlfjc5FLUg
// 目前只探测 test 与 主网

var ELK_ENV = {
  PROD: 'mainnet',
  TESTNET: 'testnet',
  TEST: 'test',
  DEV: 'dev'
};

// 断网重试时间
var TIMEOUT = 2000;
var offlineTimer = 0;
var isByCloud = /bycloud/.test(window.location.hostname);
var getEnv = function getEnv() {
  if (isProd) {
    return ELK_ENV.PROD;
  }
  if (isTestnet) {
    return ELK_ENV.TESTNET;
  }
  if (isTest) {
    return ELK_ENV.TEST;
  }
  return ELK_ENV.DEV;
};
var config = {
  env: getEnv(),
  logLevel: !isProdOrTestnet ? EnumLogLevel.Error : EnumLogLevel.None
};

// 只有testnet 和 主网使用默认值, dev，test，bycloud 使用自己的domain
if (!isProdOrTestnet || isProd && isByCloud) {
  var host = getServiceHost().API2_HOST;
  if (host.startsWith('//')) {
    host = "".concat(window.location.protocol).concat(host);
  }
  config.cdnLinks = ["".concat(host, "/t1")];
}
var HatsWebSdk = function () {
  var instance = null;
  function Init() {
    var _sdk$network;
    var conf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var sdk = new HATSWebH3(_objectSpread(_objectSpread({}, config), conf));
    // sdk.config.includeHttpRegexp = [
    //   '/v2',
    //   '/v3',
    //   '/register',
    //   '/api',
    //   '/public',
    //   '/exchange',
    //   /\/v5/,
    // ];

    // 默认120s 监听, 断网改成1s 一次刷新
    sdk === null || sdk === void 0 ? void 0 : (_sdk$network = sdk.network) === null || _sdk$network === void 0 ? void 0 : _sdk$network.notifyCdnNetworkStatus$.subscribe(function (r) {
      if ((r === null || r === void 0 ? void 0 : r.length) < 1) {
        if (offlineTimer) clearTimeout(offlineTimer);
        offlineTimer = setTimeout(function () {
          var _sdk$network2;
          sdk === null || sdk === void 0 ? void 0 : (_sdk$network2 = sdk.network) === null || _sdk$network2 === void 0 ? void 0 : _sdk$network2.refreshNetworkStatus();
        }, TIMEOUT);
      }
    });
    return sdk;
  }
  return function (conf) {
    if (!instance) {
      instance = new Init(conf);
    }
    return instance;
  };
}();
export default HatsWebSdk;